/*
    Видео с ютуба/вимео на странице
*/
let imgTemplate = '//img.youtube.com/vi/#/hqdefault.jpg';

function YouTubeGetID(url) {
    var ID = '';
    url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if(url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_\-]/i);
        ID = ID[0];
    } else {
        ID = url;
    }
    return ID;
}

export function getYoutubePreview(currFrameUrl) {
    let _previewPics = currFrameUrl.split('/');
    let previewPicUrl;

    previewPicUrl = _previewPics[_previewPics.length - 1];
    return imgTemplate.replace('#', previewPicUrl.split('?')[0]);
}

$('.video').each(function () {
    let $currVideo = $(this);
    let $currImg = $currVideo.find('img');
    let imgUrl = getYoutubePreview($currVideo.data('url'));

    if (!$currImg.length) {
        $currVideo.find('.video__inner').append(
            `<img src="${imgUrl}">`
        );
    }
});

$(document).on('click', '.video__inner', function () {
    let $currVideoInner = $(this);

    if (!$currVideoInner.find('iframe').length) {
        let $currVideoWrap = $currVideoInner.closest('.video');
        let src = $currVideoWrap.data('url');

        if (!src) return;

        // Для ютуба делаем правильный url
        if (src.indexOf('youtube.com/') !== -1 || src.indexOf('youtu.be/') !== -1 ) {
            const id = YouTubeGetID(src);
            src = 'https://www.youtube.com/embed/' + id;
        }

        $currVideoInner.append('<iframe src="'+ src +'?title=0&byline=0&portrait=0&autoplay=1" allow="autoplay" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>');
        $currVideoWrap.addClass('_active').find('iframe').trigger('click');
    }
});



// WEBPACK FOOTER //
// ./_src/js/Video.js